<template>

	<div class="bio-card" js-bio-card v-if="bio">
		<div class="bio-card__content">
			<div class="bio-card__content-front" js-bio-card-front>
				<div class="bio-card__photo" v-if="bio.photo">
					<div class="bio-card__frame" v-if="bio.photo.path" :style="'background-image: url(' + bio.photo.path + ');'"></div>
				</div>
				<div class="bio-card__details">
					<h3 class="bio-card__name">{{ bio.name }}</h3>
					<div class="bio-card__position">{{ bio.position }}</div>
					<a v-if="bio.cta" :href="bio.cta.linkURL" class="cta-primary" :aria-label="'Read more about ' + bio.name">
						{{ bio.cta.linkText }}
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
					</a>
				</div>
				<div class="bio-card__more-info" v-if="bio.moreInfoContent">
					<button type="button" class="bio-card__icon bio-card__icon--info" js-more-info :aria-controls="moreInfoId">
						<span class="sr-only">More information</span>
						<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 46 100" xml:space="preserve"><path d="M34.7,1.8c6.5,0,9.7,4.4,9.7,9.4c0,6.3-5.6,12.1-12.9,12.1c-6.1,0-9.7-3.6-9.5-9.6C22,8.7,26.2,1.8,34.7,1.8z
					M14.9,98.2c-5.1,0-8.8-3.1-5.3-17l5.8-24.5c1-3.9,1.2-5.5,0-5.5c-1.5,0-8.1,2.7-12.1,5.4l-2.5-4.2c12.4-10.5,26.6-16.7,32.8-16.7
					c5.1,0,5.9,6.1,3.4,15.6L30.3,77c-1.2,4.6-0.7,6.1,0.5,6.1c1.5,0,6.5-1.9,11.5-5.8l2.9,3.9C33.1,93.4,19.9,98.2,14.9,98.2z" class="st0"></path></svg>
					</button>
				</div>
			</div>
			<div class="bio-card__content-back" v-if="bio.moreInfoContent" :id="moreInfoId" js-bio-card-back aria-hidden="true">
				<div class="bio-card__close-info">
					<button type="button" class="bio-card__icon bio-card__icon--close" js-close-info :aria-controls="moreInfoId" tabindex="-1">
						<span class="sr-only">Close information</span>
						<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 212.982 212.982" xml:space="preserve"><g><path d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312
							c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312
							l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937
							c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z" style="fill-rule: evenodd; clip-rule: evenodd;"></path></g></svg>
					</button>
				</div>
				<div class="bio-card__summary">
					<div v-html="bio.moreInfoContent"></div>
					<a v-if="bio.cta" :href="bio.cta.linkURL" class="cta-primary" :aria-label="'Read more about ' + bio.name" tabindex="-1">
						{{ bio.cta.linkText }}
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve" class="icon-arrow-right"><path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z"></path></svg>
					</a>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>

	export default {
		name: 'Bio',
		
		props: ['bio'],
		
		computed: {
			moreInfoId() {
				if (!this.bio || !this.bio.name) {
					return '';
				}
				// Convert person name to clean Pascal case ID with unique suffix
				let personNamePart = (this.bio.name || '').replace(/[^\w]/g, '');
				if (personNamePart.length > 0) {
					personNamePart = personNamePart.charAt(0).toUpperCase() + personNamePart.substring(1);
				}
				// Use bio.id if available, otherwise generate a simple unique suffix
				const idSuffix = (this.bio.id || Math.random().toString(36).substring(2, 10)).replace(/[^a-zA-Z0-9]/g, '').substring(0, 8);
				return personNamePart + '_' + idSuffix;
			}
		}
	}
	
</script>